import fphotographer from './female-photographer.webp'
import fphotographer2 from './female-photographer2.jpeg'
import mphotographer from './male-photographer.jpeg'
import mphotographer2 from './male-photographer2.webp'
import stylist from './stylist-img1.jpeg'
import makeup from './makeup-artist.webp'


const teams = [
  {
    id: 1,
    img: fphotographer,
    name: 'Lilian',
    profession: 'Photographer'
  },
  {
    id : 2,
    img: mphotographer,
    name: 'Mike',
    profession: 'Photographer'
  },
  {
    id : 3,
    img: fphotographer2,
    name: 'Suzzy',
    profession: 'Photographer'
  },
  {
    id : 4,
    img: mphotographer2,
    name: 'Josh',
    profession: 'Photographer'
  },
  {
    id : 5,
    img: stylist,
    name: 'Derby',
    profession: 'Stylist'
  },
  {
    id : 6,
    img: makeup,
    name: 'Beth',
    profession: 'Makeup Artist'
  },
]

export default teams